/**
 * Header extra sections JS controller.
 */

const $ = jQuery;

/**
 * Class HeaderExtraSections
 */
class HeaderExtraSections {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.togglers = document.querySelectorAll( '.js-header-extra-sections-toggler' );
        this.hiddenClass = 'js-hidden';
    }

    /**
     * All common events
     * @return {void}
     */
    events() {
        if ( this.togglers ) {
            for ( const toggler of this.togglers ) {
                toggler.addEventListener( 'click', (e) => {
                    e.preventDefault();
                    this.toggle( toggler );
                } );
            }
        }
    }

    /**
     * This toggles the container visibility and attributes of the clicked link.
     *
     * @param {HTMLElement} toggler The toggler element.
     */
    toggle( toggler ) {
        const target = document.querySelector( toggler.getAttribute( 'href' ) );

        // Get icons and screen-reader texts and toggle their visibility.
        const indicators = toggler.querySelectorAll( '.js-header-extra-sections-toggler-icon, .js-header-extra-sections-toggler-desc' );
        for ( const indicator of indicators ) {
            indicator.classList.toggle( this.hiddenClass );
        }

        $( target ).slideToggle( 'fast' );
        this.toggleAriaExpanded( toggler );
    }

    /**
     * Get the toggler's aria-expanded current state and set a new opposite state to it.
     *
     * @param {HTMLElement} toggler The toggler element.
     */
     toggleAriaExpanded( toggler ) {
        const ariaExpandedState = toggler.getAttribute( 'aria-expanded' ) === 'false' ? true : false;
        toggler.setAttribute( 'aria-expanded', ariaExpandedState );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = HeaderExtraSections;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/header-extra-sections.js